import { useState } from 'react';
import { Table } from '@/components/common/atoms';
import { BREAKPOINTS, Container, Flex } from '@/ui';
import { ButtonSortQuestionnaries } from '@/components/common/molecules';
import { useTranslation } from 'react-i18next';
import { Form, Select } from 'antd';
import styled from 'styled-components';

export const TableQuestionnaires = ({ data, adminView, disabled, getFuncFromObj }) => {
  const [activeTab, setActiveTab] = useState('new');
  const { t } = useTranslation();

  const sortQuestionnariesTitle = [
    {
      value: 'new',
      label: t('NEW')
    },
    {
      value: 'passed',
      label: t('PASSED')
    },
    {
      value: 'inProgress',
      label: t('IN REVIEW')
    },
    {
      value: 'rejected',
      label: t('REJECTED')
    },
    {
      value: 'draft',
      label: t('DRAFT')
    },
    {
      value: 'verification',
      label: t('Identification')
    }
  ];

  const handleChange = (value) => {
    setActiveTab(value);
  };

  return (
    <>
      <Container $smdHidden>
        <Flex gap={24} $marginBottom={32} align={'center'} wrap>
          <ButtonSortQuestionnaries
            text={t('NEW')}
            amount={data.new && data.new.length > 0 && data?.new.length}
            active={activeTab === 'new'}
            onClick={() => setActiveTab('new')}
          />
          <ButtonSortQuestionnaries
            text={t('PASSED')}
            amount={data.passed && data.passed.length > 0 && data?.passed.length}
            active={activeTab === 'passed'}
            onClick={() => setActiveTab('passed')}
          />
          <ButtonSortQuestionnaries
            text={t('IN REVIEW')}
            amount={data.inProgress && data.inProgress.length > 0 && data?.inProgress.length}
            active={activeTab === 'inProgress'}
            onClick={() => setActiveTab('inProgress')}
          />

          <ButtonSortQuestionnaries
            text={t('REJECTED')}
            amount={data.rejected && data.rejected.length > 0 && data?.rejected.length}
            active={activeTab === 'rejected'}
            onClick={() => setActiveTab('rejected')}
          />
          <ButtonSortQuestionnaries
            text={t('DRAFT')}
            amount={data.draft && data.draft.length > 0 && data?.draft.length}
            active={activeTab === 'draft'}
            onClick={() => setActiveTab('draft')}
          />
          <ButtonSortQuestionnaries
            text={t('Identification')}
            amount={data.verification && 1}
            active={activeTab === 'verification'}
            onClick={() => setActiveTab('verification')}
          />
        </Flex>
      </Container>

      <Container $hidden $smdVisible $marginBottom={24}>
        <Form layout='vertical'>
          <Form.Item label={t('Sort by:')}>
            <StyledSelect
              options={sortQuestionnariesTitle}
              defaultValue={activeTab}
              onChange={handleChange}
            />
          </Form.Item>
        </Form>
      </Container>

      <Table
        data={data[activeTab]}
        activeTab={activeTab}
        adminView={adminView}
        isVerification={activeTab === 'verification'}
        isOpenButtonDisabled={activeTab !== 'verification' ? disabled : false}
        getFuncFromObj={getFuncFromObj}
      />
    </>
  );
};

const StyledSelect = styled(Select)`
  width: 250px !important;

  @media (max-width: ${BREAKPOINTS.smd}px) {
    width: 100% !important;
  }
`;
